/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useAppSelector } from "../../redux/Hooks/Hook";
import { GetExitBookingList } from "../../utilities/api/dashboard";
import { toast } from "react-toastify";

const ExitBooking = () => {
  const { SelectedFacility } = useAppSelector((state) => state.facilityList);
  const [fiveMinutesCourtBookingSlot, setFiveMinutesCourtBookingSlot] =
    useState<any>([]);
  const [fiveMinutesSessionSlot, setFiveMinutesSessionSlot] = useState<any>([]);
  const [fiveMinutesAssociateSlot, setFiveMinutesAssociatenSlot] =
    useState<any>([]);
  const [fifteenMinutesCourtBookingSlot, setFifteenMinutesCourtBookingSlot] =
    useState<any>([]);
  const [fifteenMinutesSessionSlot, setFifteenMinutesSessionSlot] =
    useState<any>([]);
  const [fifteenMinutesAssociateSlot, setFifteenMinutesAssociateSlot] =
    useState<any>([]);

  const GetExitBookingFive = async () => {
    const result = await GetExitBookingList("5", SelectedFacility || "");
    if (result.statusCode === 200) {
      setFiveMinutesCourtBookingSlot(result.data.courtBookingSlots);
      setFiveMinutesSessionSlot(result.data.sessionSlots);
      setFiveMinutesAssociatenSlot(result.data.associateCourtBookingSlots);
    } else {
      toast.error(result.response.data.message);
    }
  };

  const GetExitBookingFifteen = async () => {
    const result = await GetExitBookingList("15", SelectedFacility || "");
    if (result.statusCode === 200) {
      setFifteenMinutesCourtBookingSlot(result.data.courtBookingSlots);
      setFifteenMinutesSessionSlot(result.data.sessionSlots);
      setFifteenMinutesAssociateSlot(result.data.associateCourtBookingSlots);
    } else {
      toast.error(result.response.data.message);
    }
  };

  useEffect(() => {
    GetExitBookingFive();
    GetExitBookingFifteen();
  }, [SelectedFacility]);

  return (
    <>
      <Container fluid className="g-0">
        <Card>
          <Card.Body>
            <Row className="text-start fw-semibold mb-3">
              <Col lg={6}>
                <h5 className="fw-semibold">15 Minutes Remained</h5>
              </Col>
              <Col lg={6}>
                <h5 className="fw-semibold">5 Minutes Remained</h5>
              </Col>
            </Row>
            <Row className="g-4 text-start">
              <Col lg={6}>
                <Row className="g-4 text-start">
                  {fifteenMinutesCourtBookingSlot?.map((item: any) => {
                    return (
                      <Col lg={6} key={item.booking?.id}>
                        <Card className="card-orange text-white">
                          <Card.Body>
                            <div className="court-name mb-2">
                              Court Name: <b>{item.booking?.courtName}</b>
                            </div>
                            <div className="court-name mb-2">
                              Customer Name:{" "}
                              <b>
                                {item.user?.firstName} {item.user?.lastName}
                              </b>
                            </div>
                            <div className="court-name mb-2">
                              Sport: <b>{item.booking.sportName}</b>
                            </div>
                            <div className="court-name mb-2">
                              Slot:{" "}
                              <b>
                                {item.fromTime} to {item.toTime}
                              </b>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    );
                  })}
                </Row>
                <hr />
                <Row className="g-4 text-start">
                  {fifteenMinutesAssociateSlot?.map((item: any) => {
                    return (
                      <Col lg={6} key={item.booking?.id}>
                        <Card className="card-orange text-white">
                          <Card.Body>
                            <div className="court-name mb-2">
                              Court Name:{" "}
                              <b>
                                {item?.combinedCourts?.map(
                                  (elem: any) => `${elem.courtName} `
                                )}
                              </b>
                            </div>
                            <div className="court-name mb-2">
                              Associate Name: <b>{item.booking?.companyName}</b>
                            </div>
                            <div className="court-name mb-2">
                              Sport: <b>{item.booking.sportName}</b>
                            </div>
                            <div className="court-name mb-2">
                              Slot:{" "}
                              <b>
                                {item.fromTime} to {item.toTime}
                              </b>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    );
                  })}
                </Row>
                <hr />
                <Row className="g-4 text-start">
                  {fifteenMinutesSessionSlot?.map((item: any) => {
                    return (
                      <Col lg={6} key={item.session?.name}>
                        <Card className="card-orange text-white">
                          <Card.Body>
                            <div className="court-name mb-2">
                              Court Name:{" "}
                              <b>
                                {item.session?.sessionCourts?.map(
                                  (elem: any) => `${elem.court?.name} `
                                )}
                              </b>
                            </div>
                            <div className="court-name mb-2">
                              Session: <b>{item.session?.name}</b>
                            </div>
                            <div className="court-name mb-2">
                              Sport: <b>{"" + item.session?.sport?.name}</b>
                            </div>
                            <div className="court-name mb-2">
                              Slot:{" "}
                              <b>
                                {item.fromTime} to {item.toTime}
                              </b>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    );
                  })}
                </Row>
              </Col>

              <Col lg={6}>
                <Row className="g-4 text-start">
                  {fiveMinutesCourtBookingSlot?.map((item: any) => {
                    return (
                      <Col lg={6} key={item.booking?.id}>
                        <Card className="card-red text-white">
                          <Card.Body>
                            <div className="court-name mb-2">
                              Court Name: <b>{item.booking?.courtName}</b>
                            </div>
                            <div className="court-name mb-2">
                              Customer Name:{" "}
                              <b>
                                {item.user?.firstName} {item.user?.lastName}
                              </b>
                            </div>
                            <div className="court-name mb-2">
                              Sport: <b>{item.booking.sportName}</b>
                            </div>
                            <div className="court-name mb-2">
                              Slot:{" "}
                              <b>
                                {item.fromTime} to {item.toTime}
                              </b>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    );
                  })}
                </Row>
                <hr />
                <Row className="g-4 text-start">
                  {fiveMinutesAssociateSlot?.map((item: any) => {
                    return (
                      <Col lg={6} key={item.booking?.id}>
                        <Card className="card-red text-white">
                          <Card.Body>
                            <div className="court-name mb-2">
                              Court Name:{" "}
                              <b>
                                {item?.combinedCourts?.map(
                                  (elem: any) => `${elem.courtName} `
                                )}
                              </b>
                            </div>
                            <div className="court-name mb-2">
                              Associate Name: <b>{item.booking?.companyName}</b>
                            </div>
                            <div className="court-name mb-2">
                              Sport: <b>{item.booking.sportName}</b>
                            </div>
                            <div className="court-name mb-2">
                              Slot:{" "}
                              <b>
                                {item.fromTime} to {item.toTime}
                              </b>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    );
                  })}
                </Row>
                <hr />
                <Row className="g-4 text-start">
                  {fiveMinutesSessionSlot?.map((item: any) => {
                    return (
                      <Col lg={6} key={item.session?.name}>
                        <Card className="card-red text-white">
                          <Card.Body>
                            <div className="court-name mb-2">
                              Court Name:{" "}
                              <b>
                                {item.session?.sessionCourts?.map(
                                  (elem: any) => `${elem.court?.name} `
                                )}
                              </b>
                            </div>
                            <div className="court-name mb-2">
                              Session: <b>{item.session?.name}</b>
                            </div>
                            <div className="court-name mb-2">
                              Sport: <b>{item.session?.sport?.name}</b>
                            </div>
                            <div className="court-name mb-2">
                              Slot:{" "}
                              <b>
                                {item.fromTime} to {item.toTime}
                              </b>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    );
                  })}
                </Row>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};
export { ExitBooking };
